import React from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import NavDrawer from "../../components/NavDrawer/NavDrawer";

const Buddies_Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
};

  return (
    <div style={{ minHeight: "100vh", position: "relative" }}>
      <Navbar  />  

<NavDrawer highlight="BUDDIES" />
      {/* Top Right User Info + Logout */}
    

      {/* Main Page Content */}
  <div
  style={{
    paddingTop: 120,
    textAlign: "center",
    background: "linear-gradient(135deg, #FFECD2 0%, #FCB69F 100%)",
    minHeight: "350px",
  }}
>
  <h1
    style={{
      fontSize: "3rem",
      fontWeight: 800,
      color: "#ed6767",
      letterSpacing: "2px",
      marginBottom: "8px",
      fontFamily: "'Montserrat', sans-serif",
      textShadow: "0 2px 12px rgba(237, 103, 103, 0.15)",
    }}
  >
    Be a Buddy
  </h1>
  <p
    style={{
      fontSize: "1.2rem",
      color: "#222",
      background: "#fff9",
      display: "inline-block",
      padding: "6px 22px",
      borderRadius: "16px",
      fontWeight: 500,
      boxShadow: "0 2px 10px 0 #ed676733",
      fontFamily: "'Montserrat', sans-serif",
      marginTop: "0",
    }}
  >
    by Boonzie
  </p>
</div>

    </div>
  );
};

export default Buddies_Dashboard;
